import { WebApiService } from './plugins/webApiService';
import EmployeeService from './projects/performers/service/EmployeeService';
import PerformersSaveService from './projects/performers/service/PerformersSaveService';
import PersonalSettingsService from './settings/service/PersonalSettingsService';
import UsersService from './users/base/service/UsersService'

export default class apiDataSourceMain {
	/**
	 * * Сервис команды
	 */
	EmployeeService: EmployeeService;
	/**
	 * * Севрис для сохранения сотрудников
	 */
	PerformersSaveService: PerformersSaveService;
	/**
	 * * Сервис для пользовательских настроек
	 */
	PersonalSettingsService: PersonalSettingsService;
	/**
	 * * Сервис для управления пользователями
	 */
	UsersService: UsersService;
	constructor(cookieName?: string) {
		this.EmployeeService = new EmployeeService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PerformersSaveService = new PerformersSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PersonalSettingsService = new PersonalSettingsService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.UsersService = new UsersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
